
const nodeFinder = (id, list) => {
  if(!list || list.length == 0) {
    return false
  }

  let found_item = list.find(e => e.id == id)

  if(found_item) {
    return found_item
  }
  else {
    let children = list.map(e => e.children)
    for(let i = 0; i < children.length; i++) {
      found_item = nodeFinder(id, children[i])
      if(found_item) {
        return found_item
      }
    }
  }

  return false
}

export {
  nodeFinder
}



// WEBPACK FOOTER //
// ./src/browser/components/permissions/helper-functions.js